module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-drone-960-aa891663.jpg";